import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { clientApi } from '../../services/clientService';

// Async thunk for fetching clients
export const fetchClient = createAsyncThunk(
  'client/fetchClient',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await clientApi.getClientDetails(id);
      return { response };
    } catch (error) {
      console.error('Error fetching clients:', error);
      return rejectWithValue(error.message || 'Failed to fetch clients');
    }
  }
);

// Async thunk for fetching clients
export const fetchReport = createAsyncThunk(
  'client/fetchReport',
  async ({ id, month, year }, { rejectWithValue }) => {
    try {
      const response = await clientApi.getUsageReports({ id, month, year });
      return { response };
    } catch (error) {
      console.error('Error fetching clients:', error);
      return rejectWithValue(error.message || 'Failed to fetch clients');
    }
  }
);

// Async thunk for fetching clients
export const fetchUsageStats = createAsyncThunk(
  'client/fetchUsageStats',
  async ({ id, month, year }, { rejectWithValue }) => {
    try {
      const response = await clientApi.getUsageStats({ id, month, year });
      return { response };
    } catch (error) {
      console.error('Error fetching clients:', error);
      return rejectWithValue(error.message || 'Failed to fetch clients');
    }
  }
);

const initialState = {
  client: null,
  loading: false,
  error: null,
  report: null,
  reportLoading: false,
  reportError: null,
  search: '',
  reportStats: null,
  reportStatsLoading: false,
  reportStatsError: null,
};

const clientDetailSlice = createSlice({
  name: 'clientDetail',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.onboardError = null;
    },
    clearClient: (state) => {
      state.client = null;
      state.lastKey = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch client
    builder
      .addCase(fetchClient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClient.fulfilled, (state, action) => {
        state.loading = false;
        state.client = action.payload.response;
        state.error = null;
      })
      .addCase(fetchClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReport.fulfilled, (state, action) => {
        state.reportLoading = false;
        state.report = action.payload.response;
        state.reportError = null;
      })
      .addCase(fetchReport.rejected, (state, action) => {
        state.reportLoading = false;
        state.reportStatsError = action.payload;
      });

      builder
      .addCase(fetchUsageStats.pending, (state) => {
        state.reportStatsLoading = true;
        state.reportStatsError = null;
      })
      .addCase(fetchUsageStats.fulfilled, (state, action) => {
        state.reportStatsLoading = false;
        state.reportStats = action.payload.response;
        state.reportStatsError = null;
      })
      .addCase(fetchUsageStats.rejected, (state, action) => {
        state.reportStatsLoading = false;
        state.reportStatsError = action.payload;
      });
  },
});

export const { clearError, clearClient } = clientDetailSlice.actions;
export default clientDetailSlice.reducer;
